import GlobalTitle from '~/components/atoms/Editorial/Global/GlobalTitle.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
var COLORS = {
  grey: 'btn-dark',
  white: 'btn-white',
  transparent: 'btn-transparent'
};
export default {
  name: 'CollectionBanner',
  components: {
    GlobalTitle,
    SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25;
      return {
        background_color: ((_ref25 = this.payload) != null ? (_ref25 = _ref25.primary) != null ? _ref25.background_color : _ref25 : _ref25) || '',
        background_image_url: ((_ref24 = this.payload) != null ? (_ref24 = _ref24.primary) != null ? (_ref24 = _ref24.background_image) != null ? _ref24.url : _ref24 : _ref24 : _ref24) || '',
        background_image: {
          small: formatPrismicImage((_ref23 = this.payload) != null ? (_ref23 = _ref23.primary) != null ? (_ref23 = _ref23.background_image) != null ? (_ref23 = _ref23.small) != null ? _ref23.url : _ref23 : _ref23 : _ref23 : _ref23, ['w_375']) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref22 = this.payload) != null ? (_ref22 = _ref22.primary) != null ? (_ref22 = _ref22.background_image) != null ? (_ref22 = _ref22.medium) != null ? _ref22.url : _ref22 : _ref22 : _ref22 : _ref22, ['w_375,dpr_2']) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? (_ref21 = _ref21.background_image) != null ? (_ref21 = _ref21.large) != null ? _ref21.url : _ref21 : _ref21 : _ref21 : _ref21, ['w_1440']) || EMPTY_PIXEL,
          xlarge: formatPrismicImage((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? (_ref20 = _ref20.background_image) != null ? (_ref20 = _ref20.large) != null ? _ref20.url : _ref20 : _ref20 : _ref20 : _ref20, ['w_1440,dpr_2']) || EMPTY_PIXEL
        },
        image: {
          url: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? (_ref19 = _ref19.image) != null ? _ref19.url : _ref19 : _ref19 : _ref19) || '',
          small: formatPrismicImage((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? (_ref18 = _ref18.image) != null ? (_ref18 = _ref18.small) != null ? _ref18.url : _ref18 : _ref18 : _ref18 : _ref18, ['w_375']) || formatPrismicImage((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? (_ref17 = _ref17.image) != null ? _ref17.url : _ref17 : _ref17 : _ref17, ['w_375']) || '',
          medium: formatPrismicImage((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? (_ref16 = _ref16.image) != null ? _ref16.url : _ref16 : _ref16 : _ref16, ['w_375,dpr_2']) || '',
          large: formatPrismicImage((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? (_ref15 = _ref15.image) != null ? _ref15.url : _ref15 : _ref15 : _ref15, ['w_1440']) || '',
          xlarge: formatPrismicImage((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? (_ref14 = _ref14.image) != null ? _ref14.url : _ref14 : _ref14 : _ref14, ['w_1440,dpr_2']) || ''
        },
        title: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? (_ref13 = _ref13.title) != null ? _ref13[0] : _ref13 : _ref13 : _ref13) || {},
        title_banner: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.title_banner) != null ? _ref12[0] : _ref12 : _ref12 : _ref12) || {},
        subtitle: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? (_ref11 = _ref11.subtitle_banner) != null ? _ref11[0] : _ref11 : _ref11 : _ref11) || {},
        paragraph: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.paragraph : _ref10 : _ref10) || [],
        text_color: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? _ref9.text_color : _ref9 : _ref9) || '',
        button: {
          text: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.button_text : _ref8 : _ref8) || '',
          url: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? (_ref7 = _ref7.button_url) != null ? _ref7.url : _ref7 : _ref7 : _ref7) || '',
          color: COLORS[(_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.button_color : _ref6 : _ref6],
          target: (_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? (_ref5 = _ref5.button_url) != null ? _ref5.target : _ref5 : _ref5 : _ref5
        },
        tracking: {
          data: {
            event_category: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.event_category : _ref4 : _ref4) || '',
            event_action: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_action : _ref3 : _ref3) || '',
            event_label: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_label : _ref2 : _ref2) || ''
          }
        },
        size: (_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.size : _ref : _ref
      };
    },
    type() {
      return this.currentPayload.button.url ? 'a' : 'div';
    },
    isGridWidthLayout() {
      return this.currentPayload.size === false;
    },
    hasBackground() {
      return this.currentPayload.background_color || this.currentPayload.background_image_url;
    }
  }
};